import { useMemo } from "react";
import { Search } from "../interfaces";

type UseSearchFilterProps = {
  data?: Search["data"];
  filters: {
    sport?: string;
    venue?: string;
    category?: string;
    date?: Date;
    toDate?: string;
    fromDate?: string;
  };
};

export const useSearchFilter = ({ data, filters }: UseSearchFilterProps) =>
  useMemo(() => {
    if (!data) return {};
    let filteredData = { ...data };

    if (filters.fromDate || filters.toDate) {
      for (const [categoryKey, categoryData] of Object.entries(filteredData)) {
        if (categoryKey === "clubs") continue;
        if (!(categoryKey in filteredData)) continue;

        // @ts-ignore
        filteredData[categoryKey] = categoryData?.filter(
          (item) =>
            "startTime" in item &&
            new Date(item.startTime as string) >=
              new Date(filters.toDate as string) &&
            new Date(filters.fromDate as string) >=
              new Date(item.startTime as string)
        );
      }
    }

    if (filters.category) {
      // @ts-ignore
      filteredData = { [filters.category]: data[filters.category] };
    }

    if (filters.sport) {
      for (const [categoryKey, categoryData] of Object.entries(filteredData)) {
        if (categoryKey === "clubs") continue;
        if (!(categoryKey in filteredData)) continue;

        // @ts-ignore
        filteredData[categoryKey] = categoryData?.filter(
          (item) => "sport" in item && filters?.sport === item?.sport
        );
      }
    }

    return filteredData;
  }, [data, ...Object.values(filters)]);
